import { useSelector } from 'react-redux'
import { getAccessToken } from '../reducers/userAccount/selectors/credentials'

export const useGoToPremium = (): any => {
  const key = useSelector(getAccessToken)
  const hostname = window && window.location && window.location.hostname
  var uri = ''
  if (
    hostname === 'app.bed-booking.com' ||
    hostname === 'react.bed-booking.com' ||
    hostname === 'pwa.bed-booking.com'
  ) {
    uri = `https://panel.bed-booking.com/index/login?autologinkey=${key}&redirect=/payment`
  } else {
    uri = `https://rc.bed-booking.com/index/login?autologinkey=${key}&redirect=/payment`
  }
  return [
    () => {
      window.open(uri, '_blank')
    },
    uri,
  ]
}
